// extracted by mini-css-extract-plugin
export var modal = "_us-0";
export var table = "_us-1";